<template>
  <div>

    <ModalLogin :show="showModal" :error="error" @close="showModal = false"></ModalLogin>

    <div class="w-full h-10 bg-black lg:fixed lg:inset-y-0">
      <div class="fixed top-4 right-4 z-50">
        <div ref="dropdownRef" class="relative">
          <button @click="toggleDropdown"
            class="bg-white border rounded-lg shadow px-2 py-2 text-sm font-medium hover:bg-gray-100">
          <img
  src="https://flagcdn.com/36x27/gb.png"
  srcset="https://flagcdn.com/72x54/gb.png 2x,
    https://flagcdn.com/108x81/gb.png 3x"
  width="36"
  height="27"
  alt="English"> 
          </button>

          <div v-if="showDropdown"
            class="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded-lg shadow-lg">
            <ul>
              <li class="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-2"
                @click="selectLanguage('es')">
              <img
  src="https://flagcdn.com/36x27/cl.png"
  srcset="https://flagcdn.com/72x54/cl.png 2x,
    https://flagcdn.com/108x81/cl.png 3x"
  width="36"
  height="27"
  alt="Español">  {{ $t('español') }}
              </li>
              <li class="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-2"
                @click="selectLanguage('en')">
                
                <img
  src="https://flagcdn.com/36x27/gb.png"
  srcset="https://flagcdn.com/72x54/gb.png 2x,
    https://flagcdn.com/108x81/gb.png 3x"
  width="36"
  height="27"
  alt="English">
                {{ $t('ingles') }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-cover bg-center w-full min-h-screen flex items-center justify-center" style="
        background-image: url('https://www.oxytek.cl/images/clouds-intro.jpg');
      ">
      <div class="min-h-full flex flex-col">
        <div class="m-1 lg:mt-12 xl:mt-6 sm:mx-auto sm:w-full sm:max-w-md">
          <div class="flex items-center justify-center text-center ">
            <img class="w-60" src="https://www.oxytek.cl/images/logo-intro-ingenieria-3t.png" alt="Oxytek" />
          </div>
               <span v-if="!visible">Cambiando a Español</span>
        </div>

        <div v-if="visible" class="pt-1 sm:mx-auto sm:w-full sm:max-w-md">
          <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-6 lg:px-6">

            <div class="flex items-center justify-center text-center p-3 text-blue-800">
              {{ this.mensaje }}
            </div>
            <form class="space-y-6" @submit.prevent="handleSubmit">
              <div>
                <label for="userName" class="block text-sm font-medium text-gray-700">
                  {{ $t('usuario') }}
                </label>
                <div class="mt-1">
                  <input id="userName" v-model="userName" name="userName" type="text" autocomplete="userName" 
                    class="text-lg appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" />

                </div>
                 <p v-if="err_username" class="text-red-500 text-sm mt-2">
                       {{  $t('username requerido')}}
                 </p>
              </div>

              <div>
                <label for="password" class="block text-sm font-medium text-gray-700">
                  {{ $t('contraseña') }}
                </label>
                <div class="relative w-full mb-3 mt-1">
               
                  <input id="password" v-model="password" name="password" :type="type0" autocomplete="current-password"
                   class="text-lg appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" />
                  <div class=" absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5 ">
                    <p class=" mt-1"> <a @click="showPassword">{{ btnText0 }}</a></p>
                  </div>

                    <p v-if="err_password" class="text-red-500 text-sm mt-2">
                       {{  $t('password requerida')}}
                    </p>
                </div>
              </div>


 
              <div   class="flex items-center justify-center text-center p-3 text-blue-800">
              
           
                <vue-recaptcha 
                  sitekey="6LdgnAcpAAAAAJHBHchPcK5qJjGc1oEa55pFpJTr" size="normal"
                  theme="es" hl="en" :loading-timeout="loadingTimeout" @verify="recaptchaVerified"
                  @expire="recaptchaExpired" @fail="recaptchaFailed" @error="recaptchaError"
                  ref="vueRecaptcha"></vue-recaptcha>

              </div>
 

              <div> 
                <button type="submit"
                  class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                  {{ $t('entrar') }}
                </button>

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isOnline == false" class="sticky bottom-0 bg-red-500 text-white text-center py-4"
      style='z-index:10000000'>
      <p>{{ $t('sinconexion') }}</p>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { mapActions } from "vuex";
import router from "../../router";
import ModalLogin from "./ModalLogin";
import DOMPurify from "dompurify";
import vueRecaptcha from "vue3-recaptcha2";
 
import i18n from '@/i18n';
export default {
  name: "LoginRootCaptcha",
  components: {
    vueRecaptcha,
    ModalLogin,
  },
  created() {
    this.checkInternet();
    window.addEventListener("online", this.checkInternet);
    window.addEventListener("offline", () => (this.isOnline = false));
  },
  mounted() {
    window.localStorage.removeItem("user");

    if (typeof window !== 'undefined') {
      document.addEventListener('click', this.handleClickOutside)

   
    }
    this.hl =   i18n.global.t('captcha_val');
  },
  data() {
    return {
      visible:true,
      type0: 'password',
      isOnline: false,
      showRecaptcha: true,
      loadingTimeout: 30000, // 30 seconds
      userName: "",
      password: "",
      showModal: false,
      status: "0",
      token: "",
      mensaje: "",
      verificado: false,
      keycliente: "6LdgnAcpAAAAAJHBHchPcK5qJjGc1oEa55pFpJTr",
      showDropdown: false,
      dropdownRef: { value: ref(null) },
      btnText0:  ref(     i18n.global.t('mostrar')),
      hl : '',
      err_password:false,
      err_username:false
    };
  },
  methods: {
    ...mapActions("auth", ["login"]),
    showPassword() {
    
      if (this.type0 === 'password') {
        this.type0 = 'text'
        this.btnText0 =  i18n.global.t('ocultar')
      } else {
        this.type0 = 'password'
        this.btnText0 =     i18n.global.t('mostrar')
      }
    },
    async checkInternet() {
      try {

        await fetch("https://monitorweb.oxytek.cl/", { mode: "no-cors" });
        this.isOnline = true;
      } catch (error) {
        this.isOnline = false;
      }
    },
    updModal() {
      this.showModal = true;
    },
    async handleSubmit() {

      this.err_username = this.userName === '';
      this.err_password = this.password === '';
      if(this.err_username || this.err_password ){
          return false;
      }
      console.log(  this.err_username, this.err_username)
      if (!this.verificado) {
        this.error = i18n.global.t('debemarcarcaptcha');
        this.updModal();
        return false;
      }

      try {
        this.mensaje =   i18n.global.t('ingresandoasitio');

        let e = DOMPurify.sanitize(this.userName);
        let p = DOMPurify.sanitize(this.password);
        await this.$store.dispatch("login", { e, p });
        console.log('status', this.$store.state.login.statusLogin)
        if (this.$store.state.login.statusLogin == 200) {
          console.log(this.mensaje);
          router.push("/home");
        } else {
          if (this.$store.state.login.statusLogin == 300) {
            this.error =   i18n.global.t('error_datos_novalidos');
            this.updModal();

          } else {
            if ([404].includes(this.$store.state.login.statusLogin)) {
              this.error =  i18n.global.t('error_servicios_nodisponibles');
              this.updModal();
            } else {
              this.error =i18n.global.t('error_solicitud_nosepuedeenviar');
              this.updModal();
              this.isOnline = false;
            }
          }
        }
      } catch (err) {
        this.error =i18n.global.t('error_interno_servidor');
        this.updModal();
        console.log(err);
        this.mensaje = err;
      }
    }, 
    async recaptchaVerified(response) {
      console.log("respuesta", response);

      const url = "https://www.google.com/recaptcha/api/siteverify";
      const token = response;
      const clave = this.keycliente;
      const data = {
        Secret: clave,
        respuesta: token,
      };

      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Respuesta del servidor:", data);
          // Realizar acciones adicionales con la respuesta del servidor
        })
        .catch((error) => {
          console.error("Error al realizar la solicitud POST:", error);
          // Manejar errores
        });

      this.verificado = true;
    },
    recaptchaExpired() {
      this.$refs.vueRecaptcha.reset();
    },
    recaptchaFailed() { },
    recaptchaError(reason) {
      console.log("reason", reason);
    },


    toggleDropdown() {
      this.showDropdown = !this.showDropdown
    },

    selectLanguage(lang) {  

      const l = ref(i18n.global.locale.value);
      console.log('lang', l)

      i18n.global.locale.value = lang;
      localStorage.setItem('lang', lang);
 

      this.showDropdown = false
      if (lang=='es'){
        console.log('redirige')
        this.visible=false
         parent.window.location.href='/es';
      }
    
     
    },

    handleClickOutside(event) {
      console.log('event', event._vts)
      if (
        !event._vts
      ) {
        this.showDropdown = false
      }
    },


 reloadRecaptchaScript(hl) {
  const oldScript = document.querySelector('script[src^="https://www.google.com/recaptcha/api.js"]');
  if (oldScript) {
    document.head.removeChild(oldScript);
  }

  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=explicit&hl=${hl}`;
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    document.head.appendChild(script);
  });
}


  },
    watch: {
    async hl(value) {
      this.reloadRecaptchaScript(value)
      
    },
  },
 
}
</script>
